/* eslint unused-imports/no-unused-imports: "off" */
import React from "react"
import {BreadcrumbsUIComponent} from "@next/breadcrumbs"
import {useScrollTrigger} from "@mui/material"
import {checkIfMerchandisedUrl} from "@next/utils"
import {Breadcrumbs} from "../../../../models/SearchState"
import {TextModel} from "../../../../models/Text"
import Products from "../../../../components/products"
import FiltersComponent from "../../../../components/filters"
import MobileHeader from "../../../../components/mobileHeader"
import ResultsGrid from "../../../../components/resultsGrid"
import ViewAllModal from "../../../../components/viewAllModal"
import NoResults from "../../../../components/noResults"
import CategoryQuickLinks from "../../../../components/categoryQuickLinks"
import {
    CategoryQuickLinksContainer,
    NoResultsContainer,
    BreadcrumbsContainer,
    BreadcrumbsSection,
} from "../../components"
import {RelativeContainer} from "./components"
import PlpContainer from "../../../../components/container"
import ProductsHeader from "../../../../components/productsHeader"
import {STICKY_HEADER_SCROLL_TRIGGER} from "../../../../config/constants"
import {httpUrlTrimmer} from "../../../../utils/httpUrlTrimmer"
import trimUrlByOneCategorySegment from "../../../../utils/trimUrlByOneCategorySegment"
import getSiteUrlForCategory from "../../../../utils/getSiteUrlForCategory"
import {ParsedObject} from "../../../../utils/getBreadcrumbsUrlValues"
import connect from "./connect"
import SearchBannerProvider from "../../../../components/searchBannerProvider"
import {getBreadcrumbsHomeIcon} from "../../../../utils/getBreadcrumbsHomeIcon"
import SaleClearanceSearchBar from "../../../../components/saleClearanceSearchBar"

export interface Cotton22PLPResultsContainerProps {
    noResults: boolean
    breadcrumbs: Breadcrumbs
    breadcrumbsValues: ParsedObject[]
    url: string
    text: TextModel
    realm: string
    urlIsSaleOrClearance: boolean
}

export const Cotton22PLPResultsContainer = ({
    noResults,
    breadcrumbs,
    breadcrumbsValues,
    url,
    text,
    realm,
    urlIsSaleOrClearance,
}: Cotton22PLPResultsContainerProps) => {
    const breadcrumbsBackUrl = trimUrlByOneCategorySegment(url)
    const breadcrumbsHomeUrl = getSiteUrlForCategory(url)
    const isMerchandisedUrl = checkIfMerchandisedUrl(httpUrlTrimmer(url))
    const sticky = useScrollTrigger({threshold: STICKY_HEADER_SCROLL_TRIGGER})
    const {
        pages: {
            breadcrumbs: {backText, homeText, expandAltText},
        },
    } = text
    return noResults ? (
        <PlpContainer testId="plp-container">
            <NoResultsContainer>
                <NoResults />
            </NoResultsContainer>
            <CategoryQuickLinksContainer>
                <CategoryQuickLinks />
            </CategoryQuickLinksContainer>
        </PlpContainer>
    ) : (
        <>
            {breadcrumbs.enabled && isMerchandisedUrl && (
                <BreadcrumbsSection>
                    <BreadcrumbsContainer
                        id="plp-breadcrumbs-container"
                        data-testid="plp-breadcrumbs-container"
                        sticky={sticky}
                    >
                        <BreadcrumbsUIComponent
                            expandText={expandAltText}
                            itemsAfterCollapse={1}
                            itemsBeforeCollapse={1}
                            maxItems={10}
                            separator="/"
                            isBackButton={breadcrumbs.breadcrumbsIcons.enableBackButton}
                            isHomeIcon={breadcrumbs.breadcrumbsIcons.enableHomeIcon}
                            homeIcon={getBreadcrumbsHomeIcon("home.svg", realm)}
                            homeUrl={breadcrumbsHomeUrl}
                            backUrl={breadcrumbsBackUrl}
                            backText={backText}
                            homeText={homeText}
                            urlSegments={breadcrumbsValues}
                            id="plp-breadcrumbs-navigation"
                            data-testid="plp-breadcrumbs-navigation"
                        />
                    </BreadcrumbsContainer>
                </BreadcrumbsSection>
            )}
            <PlpContainer testId="plp-container">
                <RelativeContainer data-testid="plp-mobile-header">
                    <MobileHeader />
                </RelativeContainer>
                <ResultsGrid container $urlIsSaleOrClearance={urlIsSaleOrClearance}>
                    <SearchBannerProvider paddingTop={3.75}>
                        <ProductsHeader />
                    </SearchBannerProvider>
                    <SaleClearanceSearchBar />
                    <FiltersComponent datatestId="plp-filters-component-desktop" />
                    <Products />
                </ResultsGrid>
                <ViewAllModal />
            </PlpContainer>
        </>
    )
}

export default connect(Cotton22PLPResultsContainer)
